import IS_BROWSER from '../isBrowser/index.js';
import Logger from '../services/logger/index.js';

var getDeviceId = function getDeviceId() {
  try {
    return IS_BROWSER && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('paa_did')) || '';
  } catch (e) {
    Logger.error(e);
  }
};

export { getDeviceId as default };
//# sourceMappingURL=index.js.map
